import { maxPage } from "../help";
import { SET_CURRENCIES, SET_HISTORY, SET_MAX_PAGE } from "./types";

const initialBookState = {
  maxPage: localStorage.getItem("maxPage") || maxPage,
  currencies: [],
  history: [],
};

const mainReducer = (state = initialBookState, { type, payload }) => {
  switch (type) {
    case SET_MAX_PAGE: {
      const { page } = payload;
      return {
        ...state,
        maxPage: page,
      };
    }
    case SET_CURRENCIES: {
      const { newCurrencies } = payload;
      return {
        ...state,
        currencies: [...newCurrencies],
      };
    }
    case SET_HISTORY: {
      const { historyData } = payload;
      return {
        ...state,
        history: [...historyData],
      };
    }
    default: {
      return state;
    }
  }
};

export default mainReducer;
